export default __webpack_public_path__ + "static/media/circleNoneTp.ae779c8d.svg";